"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GamingChatInner = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const stream_chat_1 = require("stream-chat");
const stream_chat_react_1 = require("stream-chat-react");
const GamingMessage_1 = require("./GamingMessage");
const GamingMessageInput_1 = require("./GamingMessageInput");
const GamingThread_1 = require("./GamingThread");
const LayoutController_1 = require("../../context/LayoutController");
const ChatLoginButton_1 = require("./ChatLoginButton");
const useCustomCommands_1 = require("../../hooks/useCustomCommands");
const NOTIFICATION_TEXT_FOR_COMMAND = {
    "/ban": "User banned",
    "/flag": "User flagged",
    "/mute": "User muted",
    "/unban": "User unbanned",
    "/unmute": "User unmuted",
};
const getNotificationText = (messageText) => {
    for (let command of Object.keys(NOTIFICATION_TEXT_FOR_COMMAND)) {
        if (messageText === null || messageText === void 0 ? void 0 : messageText.startsWith(command))
            return NOTIFICATION_TEXT_FOR_COMMAND[command];
    }
    return null;
};
const GamingChatInner = ({ info }) => {
    const { sendMessage } = (0, stream_chat_react_1.useChannelActionContext)();
    const { publishAppNotification } = (0, LayoutController_1.useLayoutController)();
    const commands = (0, useCustomCommands_1.useCustomCommands)();
    const triggerChatCommand = (text, commands) => {
        if (!text.startsWith(commands.prefix))
            return;
        commands.list.forEach((command) => {
            if (text.toLowerCase() === `${commands.prefix}${command.command}`.toLowerCase()) {
                fetch("/stream/chat-command", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "X-Requested-With": "XMLHttpRequest",
                    },
                    body: JSON.stringify({
                        channelId: info.channelId,
                        siteChannelId: info.siteChannelId,
                        command: command.command,
                    }),
                }).catch((e) => console.log(e));
            }
        });
    };
    const overrideSubmitHandler = (0, react_1.useCallback)((message) => {
        const { text } = message;
        publishAppNotification(getNotificationText(text));
        const sendMessagePromise = sendMessage(message);
        (0, stream_chat_1.logChatPromiseExecution)(sendMessagePromise, "send message");
        if (text && commands) {
            triggerChatCommand(text, commands);
        }
    }, [publishAppNotification, sendMessage, triggerChatCommand, commands]);
    let messageInput;
    if (info.userIsLoggedIn) {
        messageInput = ((0, jsx_runtime_1.jsx)(stream_chat_react_1.MessageInput, { focus: true, grow: true, Input: GamingMessageInput_1.GamingMessageInput, overrideSubmitHandler: overrideSubmitHandler }));
    }
    else {
        messageInput = (0, jsx_runtime_1.jsx)(ChatLoginButton_1.ChatLoginButton, {});
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(stream_chat_react_1.Window, { children: [(0, jsx_runtime_1.jsx)(stream_chat_react_1.MessageList, { Message: GamingMessage_1.GamingMessage }), messageInput] }), (0, jsx_runtime_1.jsx)(GamingThread_1.GamingThread, {})] }));
};
exports.GamingChatInner = GamingChatInner;
